import { createFileRoute } from "@tanstack/react-router"
import { sanitizeRedirectPath } from "@/contexts/authRedirect"

export interface LoginSearchParams {
  redirect?: string
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => ({
    redirect: sanitizeRedirectPath(search.redirect as string | undefined),
  }),
})
